import { Pipe, PipeTransform } from '@angular/core';
import {Constants} from '../constants';

@Pipe({
  name: 'toAttributeName'
})
export class ToAttributeNamePipe implements PipeTransform {

  transform(value): any {
    if (typeof value === 'boolean') {
      return value;
    }
    if (!value) {
      return;
    }
    if (value.search(`${Constants.ATTR_PRE_LABEL}${Constants.DOT}`) === 0
      || value.search(`${Constants.LOCATION_PRE_LABEL}${Constants.DOT}`) === 0) {
      return value.split(Constants.DOT)[1];
    }
    return value;
  }

}



// WEBPACK FOOTER //
// ./src/app/rules/pipes/to-attribute-name.pipe.ts